import { render, staticRenderFns } from "./SSO.vue?vue&type=template&id=ac29ef12&scoped=true&"
import script from "./SSO.vue?vue&type=script&lang=js&"
export * from "./SSO.vue?vue&type=script&lang=js&"
import style0 from "./SSO.vue?vue&type=style&index=0&id=ac29ef12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac29ef12",
  null
  
)

export default component.exports